// Updated CheckoutList.js (only changed/added parts compared to your version)
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  Badge,
  Modal,
  Form,
  Alert,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ElementPage from "../../Elements";
import LogoutPage from "../auth-pages/LogoutPage";
import CustomerAddressForm from "./CustomerAddressForm";
import { toast } from "react-toastify";
import {
  getGenerateByCustomerIDApi,
  getStateGetCustomerAddressesByCustomerIDApi,
  otp_VerificationApi,
  placeCustomerOrderApi,
} from "../CustomerCRUD";

const CheckoutList = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const navigate = useNavigate();
  const pathUrl = process.env.REACT_APP_API_URL;
  const [customer, setCustomer] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  // address related
  const [address, setAddress] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerAddressID, setCustomerAddressID] = useState(1);
  const [customerAddressData, setCustomerAddressData] = useState([]);

  useEffect(() => {
    const storedCustomer = localStorage.getItem("customer");
    setCustomer(storedCustomer ? JSON.parse(storedCustomer) : null);

    const storedAddress = localStorage.getItem("checkoutAddress");
    setAddress(storedAddress ? JSON.parse(storedAddress) : null);
    getCustomerAddressByCustomerId();
  }, []);

  // -------------------start customer address get api ---------------------------

  const getCustomerAddressByCustomerId = async () => {
    try {
      const res = await getStateGetCustomerAddressesByCustomerIDApi(
        customer.customerID
      );
      if (res.data.isSuccess) {
        const activeAddresses = res.data.responseObject;
        setCustomerAddressData(activeAddresses);
      }
    } catch (err) {
      console.error("Address fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  //---------------------------------------
  const isLoggedIn = !!customer;
  // totals (make finalTotal numeric to send in payload)
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.qty,
    0
  );
  // const discount = totalPrice > 1000 ? totalPrice * 0.1 : 0;
  // const tax = totalPrice * 0.05;
  const finalTotalNumber = Number(totalPrice.toFixed(2));

  const handleAddressSave = (addr) => {
    setAddress(addr);
    setShowAddressModal(false);
    setCustomerAddressID(1);
  };

  // ---------------- OTP Generate-----------------------
  // const [otpGenerate, setOtpGenerate] = useState({});
  // const [otpGenerating, setOtpGenerating] = useState(false);
  // const handleProceedToOtp = async () => {
  //   if (!isLoggedIn) {
  //     navigate("/login");
  //     return;
  //   } // require address before sending OTP
  //   if (!address) {
  //     setError("Please provide delivery address before confirming order.");
  //     toast.error("Please provide delivery address before confirming order.");
  //     return;
  //   }

  //   setIsSendingOtp(true);
  //   setError("");
  //   setSuccess("");

  //   try {
  //     setOtpGenerating(true);
  //     // try {
  //     const res = await getGenerateByCustomerIDApi(customer.customerID);
  //     if (res.data.isSuccess) {
  //       setOtpGenerate(res.data.responseObject);
  //       toast.success("OTP sent successfully.");
  //       setShowOtpModal(true);
  //       setOtpGenerating(true);
  //     }
  //     // } catch (err) {
  //     //   toast.error(`${err.message} Error generating OTP`);
  //     // }
  //     // const response = await fetch(`${pathUrl}/api/otp/send`, {
  //     //   method: "POST",
  //     //   headers: {
  //     //     "Content-Type": "application/json",
  //     //   },
  //     //   body: JSON.stringify({
  //     //     customerId: customer.id,
  //     //     mobileNumber: address.mobileNumber || customer.mobileNumber,
  //     //     email: customer.email,
  //     //   }),
  //     // });

  //     // if (!response.ok) {
  //     //   const txt = await response.text();
  //     //   throw new Error(txt || "Failed to send OTP");
  //     // }

  //     // setSuccess("OTP sent successfully to your mobile/email.");
  //   } catch (err) {
  //     setError("Error sending OTP. Please try again.");
  //   } finally {
  //     setIsSendingOtp(false);
  //   }
  // };

  const handleProceedOrder = async () => {
    // setIsVerifyingOtp(true);
    // const otp = otpInputValue; // Get the OTP value from the input
    if (!isLoggedIn) {
      navigate("/login");
      return;
    } // require address before sending OTP
    if (!address) {
      setError("Please provide delivery address before confirming order.");
      toast.error("Please provide delivery address before confirming order.");
      return;
    }
    try {
      // const res = await otp_VerificationApi(customer.customerID, otp);
      // if (res.data.isSuccess) {
      //   setSuccess("OTP verified successfully.");

      // 2. Prepare order payload
      // const lineTotal = item.price * item.qty;
      const orderPayload = {
        customerID: customer.customerID,
        subTotal: totalPrice,
        discount: 0,
        tax: 0,
        finalTotal: finalTotalNumber,
        items: cartItems.map((item) => ({
          productCategoryID: item.prodCatgryID,
          productID: item.id,
          qty: item.qty,
          rateOnOrder: item.price,
          lineTotal: item.price * item.qty,
        })),
      };

      localStorage.setItem("order", JSON.stringify(orderPayload));
      // 3. Call order API
      setLoading(true);
      const orderRes = await placeCustomerOrderApi(orderPayload);
      if (orderRes.data.isSuccess) {
        setSuccess(
          `Order placed successfully! Order ID: ${orderRes.data.orderID}`
        );

        // Redirect to payment page with orderID
        navigate(`/payment/${orderRes.data.orderID}`);
      } else {
        setError("Order failed. Please try again.");
      }
      // } else {
      //   setError("Invalid OTP. Please try again.");
      // }
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
      // setIsVerifyingOtp(false);
      // setShowOtpModal(false);
      // setOtpGenerating(false);
    }
  };

  return (
    <>
      <div className="px-8 container-fluid py-3">
        <div className="d-flex justify-content-end">
          <LogoutPage />
        </div>

        <Row className="g-4 px-4">
          {customer && (
            <div className="p-3">
              <h5 style={{ color: "#4c934c" }}>👤 Customer Info</h5>
              <div className="ms-2">
                <p className="mb-1">
                  <strong>
                    {customer.firstName} {customer.lastName}
                  </strong>
                </p>
                <p className="mb-1">{customer.email}</p>
                <p className="mb-0">📱 {customer.mobileNumber}</p>
              </div>
            </div>
          )}

          <Col md={12}>
            <Card className="shadow-sm p-3">
              <h5 className="mb-2 fs-5">🛒 Your Cart</h5>
              {cartItems.length === 0 ? (
                <>
                  <p className="text-muted text-center">Your cart is empty.</p>{" "}
                  <div className="text-center mx-2">
                    <button
                      className="btn btn-sm mt-2"
                      style={{ backgroundColor: "#4c934c", color: "white" }}
                      onClick={() => navigate("/page/products")}
                    >
                      Add Item
                    </button>
                  </div>{" "}
                </>
              ) : (
                <ListGroup variant="flush">
                  <ListGroup.Item
                    className="fw-bold"
                    style={{ backgroundColor: "#4c934c", color: "#fff" }}
                  >
                    <Row>
                      <Col md={2}>Image</Col>
                      <Col md={2} className="text-truncate">
                        Category
                      </Col>
                      <Col md={2} className="text-truncate">
                        Product
                      </Col>
                      <Col md={2}>Qty</Col>
                      <Col md={2}>Price</Col>
                      <Col md={2}>Total</Col>
                    </Row>
                  </ListGroup.Item>

                  {cartItems.map((item) => (
                    <ListGroup.Item key={item.id} className="py-2">
                      <Row className="align-items-center">
                        <Col md={2} className="text-start">
                          <img
                            src={pathUrl + item.image}
                            alt={"img"}
                            className="img-fluid rounded"
                            style={{ maxWidth: "50px" }}
                          />
                        </Col>
                        <Col md={2} className="fw-semibold ">
                          {item.categoryName}
                        </Col>
                        <Col md={2} className="fw-semibold ">
                          {item.name}
                        </Col>
                        <Col md={2}>
                          <Badge bg="secondary">{item.qty}</Badge>
                        </Col>
                        <Col md={2}>₹{item.price}</Col>
                        <Col md={2} className="fw-bold text-success">
                          ₹{item.price * item.qty}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </Card>
          </Col>
        </Row>

        <Row className="g-4 px-4 mt-1">
          <Col md={cartItems.length == 0 ? 12 : 8}>
            {/* Address area */}
            {!address ? (
              <CustomerAddressForm
                initialAddress={null}
                onSave={handleAddressSave}
                pathUrl={pathUrl}
                customer={customer}
              />
            ) : (
              <Card className="shadow-sm p-3 ps-3 mb-2">
                <h6 style={{ color: "#4c934c" }}>Deliver To</h6>
                <p className="mb-1">
                  <strong>{address.fullName}</strong>
                </p>
                <p className="mb-1">
                  {address.addressLine1}
                  {address.addressLine2 ? ", " + address.addressLine2 : ""}
                </p>
                <p className="mb-1">
                  {address.city} - {address.postalCode}
                </p>
                <p className="mb-1">
                  {address.state}
                  {address.country}
                </p>
                <p className="mb-0">📱 {address.phoneNumber}</p>

                <div className="mt-3 d-flex gap-2">
                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() => setShowAddressModal(true)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    // onClick={() => {
                    //   // remove address and re-enter
                    //   sessionStorage.removeItem("checkoutAddress");
                    //   setAddress(null);
                    // }}
                  >
                    Change
                  </Button>
                  {/* <Button
                    size="sm"
                    variant="outline-danger"
                    className="btn btn-dange"
                    onClick={() => {
                      // remove address and re-enter
                      sessionStorage.removeItem("checkoutAddress");
                      setAddress(null);
                    }}
                  >
                    Delete
                  </Button> */}
                </div>
              </Card>
            )}
          </Col>
          {cartItems.length > 0 ? (
            <Col md={4}>
              <Card className="p-3">
                <h5
                  className="mb-3"
                  style={{ fontSize: "2.00rem", color: "#4c934c" }}
                >
                  📦 Order Summary
                </h5>
                <p className="mb-1">
                  Items: <strong>{cartItems.length}</strong>
                </p>
                <p className="mb-1">
                  No Of Quantity:{" "}
                  <strong>
                    {cartItems.reduce((acc, item) => acc + item.qty, 0)}
                  </strong>
                </p>
                <p className="mb-1">
                  Subtotal: <strong>₹{totalPrice.toFixed(2)}</strong>
                </p>
                {/* {discount > 0 && (
                <p className="mb-1 text-success">
                  Discount (10%): <strong>-₹{discount.toFixed(2)}</strong>
                </p>
              )}
              <p className="mb-1">
                Tax (5%): <strong>₹{tax.toFixed(2)}</strong>
              </p> */}
                {/* <p className="mb-1">
                Shipping: <strong className="text-success">Free</strong>
              </p> */}
                <hr />
                <h5 style={{ fontSize: "1.40rem" }}>
                  Final Total:{" "}
                  <span style={{ fontWeight: "bold", color: "#4c934c" }}>
                    ₹{finalTotalNumber.toFixed(2)}
                  </span>
                </h5>

                <Button
                  variant="danger"
                  className="w-100 fs-6"
                  onClick={handleProceedOrder}
                  style={{ backgroundColor: "#4c934c", color: "white" }}
                  disabled={cartItems.length === 0}
                >
                  {isLoggedIn ? "Confirm Order" : "Login to Checkout"}
                </Button>
                {error && (
                  <Alert variant="danger" className="mt-2">
                    {error}
                  </Alert>
                )}
                {success && (
                  <Alert variant="success" className="mt-2">
                    {success}
                  </Alert>
                )}
                {/* {otpGenerating ? (
                <>
                  {otpGenerate && (
                    <Alert variant="info" className="mt-2">
                      Your OTP is:{" "}
                      <strong className="text-success">
                        {otpGenerate.otp}
                      </strong>{" "}
                      (for demo purposes)
                    </Alert>
                  )}
                </>
              ) : null} */}
              </Card>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </div>

      {/* OTP Modal */}
      {/* <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            An OTP has been sent to your registered mobile/email. Please enter
            it below.
          </p>
          <Form.Group controlId="otp">
            <Form.Label>OTP</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={6}
            />
          </Form.Group>
          {error && (
            <Alert variant="danger" className="mt-2">
              {error}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOtpModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleVerifyOtp}
            disabled={isVerifyingOtp || otp.length !== 6}
          >
            {isVerifyingOtp ? "Verifying..." : "Verify OTP"}
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* Address Edit Modal */}
      <Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Delivery Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomerAddressForm
            initialAddress={address}
            onSave={handleAddressSave}
            pathUrl={pathUrl}
            customer={customer}
            customerAddressID={customerAddressID}
            setCustomerAddressID={setCustomerAddressID}
          />
        </Modal.Body>
      </Modal>

      <ElementPage />
    </>
  );
};

export default CheckoutList;
